module.exports = "https://cdn.ticketswap.com/_next/static/images/mobile-screen-bigger-4b08b406ea989bc9b7d5a51cf23d3ad0.jpg";